var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModalCloseBtnLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 30,
    height: 30,
    rx: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2262 24.7691C15.533 25.0759 16.0484 25.0636 16.3429 24.7753L19.9996 21.1186L23.6502 24.7753C23.9508 25.0759 24.4662 25.0759 24.7668 24.7691C25.0675 24.4624 25.0736 23.9531 24.773 23.6525L21.1224 19.9958L24.773 16.3452C25.0736 16.0446 25.0736 15.5353 24.7668 15.2286C24.4601 14.9279 23.9508 14.9218 23.6502 15.2224L19.9996 18.8791L16.3429 15.2224C16.0484 14.9341 15.5269 14.9218 15.2262 15.2286C14.9256 15.5353 14.9317 16.0507 15.2201 16.3391L18.8768 19.9958L15.2201 23.6586C14.9317 23.947 14.9195 24.4685 15.2262 24.7691Z",
    fill: "#62626F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalCloseBtnLight);
export default __webpack_public_path__ + "static/media/modal_close_btn-light.9f08224efbfbc671bee790043888642d.svg";
export { ForwardRef as ReactComponent };